import { atom } from 'recoil';

// eslint-disable-next-line import/prefer-default-export
export const searchActiveAtom = atom({
    key: 'searchActiveAtom',
    default: false
});
